"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueContainerStyle = exports.inputStyle = exports.inputContainerStyle = void 0;

var _style = require("../utils/style");

const valueContainerStyle = { ...(0, _style.buildDirectionStyle)('padding', '10px')
};
exports.valueContainerStyle = valueContainerStyle;

const inputStyle = ({
  $theme
}) => ({
  '::placeholder': {
    color: $theme.colors.grey70,
    opacity: 1
  },
  width: '100%'
});

exports.inputStyle = inputStyle;
const inputContainerStyle = { ...(0, _style.buildDirectionStyle)('margin', '0px'),
  width: '100%'
};
exports.inputContainerStyle = inputContainerStyle;